import React, { Fragment } from "react";
import styled from 'styled-components'
import { breakpoint } from 'styled-components-breakpoint';

const ImageWrapper = styled.div`
    position: relative;
    ${breakpoint('mobile')`
        height: 400px;
    `}
    width: 100%;
    overflow: hidden;
   
    img{
        width: 100%;
        ${breakpoint('mobile')`
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
        `}
    }
   
`

function TopImage(props) {
    let headerImage = (props.content.headerImages) ? props.content.headerImages[0].fields.file.url : null;
    return(
        <Fragment>
        {(headerImage) ?
            (<ImageWrapper id="topimage">
                <img src={headerImage} alt="impressie truffelhond.nl"/>
            </ImageWrapper>) : ""
        }
        </Fragment>
    )
}

export default TopImage;